import React, { PureComponent } from 'react';
import { Label, FormGroup } from 'reactstrap';
import { number, func } from 'prop-types';
import Select from '../common/Select';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  method: number.isRequired,
  onPostbackMethodChange: func.isRequired,
};

const defaultProps = {
  method: 0,
};

const methods = [
  {
    value: 0,
    label: 'POST',
  },
  {
    value: 1,
    label: 'GET',
  }
];

class FlowPostbackMethod extends PureComponent {
  render() {
    const { method, onPostbackMethodChange } = this.props;

    return (
      <FormGroup className="form-group-upper-label">
        <Label for="postback-method">
          <FMessage id="postback.global.method"/>
        </Label>
        <Select
          id="postback-method"
          name="method"
          clearable={false}
          value={method}
          onChange={({value}) => onPostbackMethodChange({method: value})}
          options={methods}
          searchable={false}
        />
      </FormGroup>
    );
  }
}

FlowPostbackMethod.propTypes = propTypes;
FlowPostbackMethod.defaultProps = defaultProps;

export default FlowPostbackMethod;
